// extracted by mini-css-extract-plugin
export default {"container":"GHIp1YejAVtVVagtynVVm","icon":"_3AqocmJxnj5bhs67vlE9tV","title":"_3DvedvHlIG7KRhl7JD6Gks","content":"_2y1_WMFbFIEO1cWQKz9exQ","buttons":"_3RA3hQBcft3mfNlif123rq"};